<div *ngIf="(vm$ | async) as vm">
    <app-page-header [vm]="vm" title='Affiliates Payout' [fullHeader]="true">
    </app-page-header>

    <mdb-card class="mb-3" cascade="true" narrower="true" *ngIf="vm.filterVm as fvm" style="height: 5rem">
        <mdb-card-body cascade="true" class="py-3">
            <div class="row">
                <div class="offset-md-1 col-md-3 mt-n3 mb-0">
                    <app-form-input [vm]="fvm.fromDateInputVm"></app-form-input>
                </div>
                <div class="col-md-3 mt-n3 mb-0">
                    <app-form-input [vm]="fvm.toDateInputVm"></app-form-input>
                </div>
                <div class="col-md-2 mt-1 mb-0">
                    <button (click)="buttonClicked(fvm.data, vm)" type="button" class="btn btn-outline-primary btn-sm waves-effect btn-block">Submit</button>
                </div>
            </div>
        </mdb-card-body>
    </mdb-card>

    <!-- Confirmation screen-->
    <div *ngIf="vm.confirmFormVm as cvm" class="my-6">
        <div class="row">
            <div class="col-md-12">
                <mdb-card narrower="true" cascade="true">
                    <mdb-card-body cascade="true">
                        <div class="text-center text-info">
                            <strong>{{cvm.message}}</strong>
                        </div>
                        <br />
                        <div class="offset-md-3 col-md-6">
                            <div class="mx-2">
                                <div class="md-form form-group form-sm">
                                    <app-form-input [vm]="cvm.reasonInputVm"></app-form-input>
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-center">
                            <app-form-ok-cancel [vm]="cvm.okCancelVm" (cancelClicked)="confirmFormCanceled(vm)"
                                (okClicked)="confirmFormOk(vm)">
                            </app-form-ok-cancel>
                        </div>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="vm.dataVm?.errorText">
        <div class="col-md-12 text-center text-danger">
            {{vm.dataVm.errorText}}
        </div>
    </div>
    
    <div class="row" *ngIf="vm.dataVm?.workingText">
        <div class="col-md-12 text-center text-info">
            <div>{{vm.dataVm.workingText}}</div>
            <mdb-spinner spinnerColor="blue"></mdb-spinner>
        </div>
    </div>
    <div class="row mt-0" *ngIf="!vm.dataVm?.workingText && !vm.dataVm?.errorText && !vm.confirmFormVm">
        <!-- left side -->
        <div class="col-md-4 mb-0">
            <!-- Search form -->
            <div class="form-inline md-form form-sm my-0">
                <mdb-icon fas icon="search" aria-hidden="true"></mdb-icon>
                <input class="form-control form-control-sm ml-5 w-75" type="search" [ngModel]="searchData"
                    (ngModelChange)="doDataSearch(vm, $event)" placeholder="Search text">
            </div>
        </div>
    </div>
    <div class="mt-3" *ngIf="!vm.dataVm?.workingText && !vm.dataVm?.errorText && !vm.confirmFormVm">
        <div *ngIf="vm.dataVm?.payoutDataVm as dvm">
            <div class="mt-3">
                <app-data-table-card-simple [vm]="dvm"
                    [showHeader]="false" [keyColumn]="0"
                    (rowActionClick)="rowActionInvoke($event, vm)">
                </app-data-table-card-simple>
            </div>
        </div>
    </div>
</div>
